<template>
  <g fill-rule="evenodd">
    <path
      d="M.8 10.4h.84a8.01 8.01 0 007.16 7.16v.84a.8.8 0 001.6 0v-.84a8.01 8.01 0 007.16-7.16h.84a.8.8 0 000-1.6h-.84a8.01 8.01 0 00-7.16-7.16V.8a.8.8 0 00-1.6 0v.84A8.01 8.01 0 001.64 8.8H.8a.8.8 0 000 1.6"
    />
    <path
      d="M8.8 3.26V4a.8.8 0 001.6 0v-.74a6.4 6.4 0 015.54 5.54h-.74a.8.8 0 000 1.6h.74a6.4 6.4 0 01-5.54 5.54v-.74a.8.8 0 10-1.6 0v.74a6.4 6.4 0 01-5.54-5.54H4a.8.8 0 000-1.6h-.74A6.4 6.4 0 018.8 3.26"
      class="secondary-color"
    />
    <path d="M9.6 8a1.6 1.6 0 110 3.2 1.6 1.6 0 010-3.2m0 4.8a3.2 3.2 0 100-6.4 3.2 3.2 0 000 6.4" />
  </g>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "AudiencesIcon",
});
</script>
